import React from "react";
import { STRING_TIPO_DE_IMAGEN } from "../../utils/const/string-const";

export default function ImageTypeSelector({ label, value, onChange, t, disabled = false }) {
    const options = [
        { value: STRING_TIPO_DE_IMAGEN.image, label: t("label_tipo_imagen_raster") },
        { value: STRING_TIPO_DE_IMAGEN.svg, label: t("label_tipo_imagen_svg") },
    ];

    return (
        <div>
            <p className="block text-md font-medium text-gray-700 mb-2">{label}</p>
            <div className="flex flex-col sm:flex-row gap-2">
                {options.map((option) => {
                    const active = value === option.value;
                    return (
                        <button
                            key={option.value}
                            type="button"
                            disabled={disabled}
                            onClick={() => onChange(option.value)}
                            className={`flex-1 rounded-xl border px-4 py-3 text-sm font-semibold transition ${
                                active
                                    ? "border-ct-primary-500 bg-ct-primary-50 text-ct-primary-800"
                                    : "border-slate-200 bg-white text-slate-700 hover:border-ct-primary-300 hover:bg-ct-primary-50/40"
                            } disabled:opacity-50 disabled:cursor-not-allowed`}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
